import { LICENSE_TYPE, LICENSE_TYPES, DRAWDOWN_PRODUCTS_NAMES } from "license/constants";
import { isDailyLicenseType } from "license/helper/activeLicense";
export const licenseProductNames = ({ products, license_type }, productName) => {
  if (license_type === LICENSE_TYPE.drawDown) {
    return products.split(",").map((product) => DRAWDOWN_PRODUCTS_NAMES[product]).filter((name) => Boolean(name)).map((name) => `${productName} ${name}`);
  }
  if (isDailyLicenseType(license_type)) {
    const name = LICENSE_TYPES[products];
    return name ? [`${productName} ${name}`] : [];
  }
  return [];
};
export default licenseProductNames;
